class AvoirsLignesModel {
    constructor(data) {
        this.id = data.id || null;
        this.avoir_id = data.avoir_id || null;

        this.designation = data.designation || null;
        this.quantite = parseFloat(data.quantite) || 1;
        this.unite = data.unite || null;
        this.prix_unitaire_centimes = data.prix_unitaire_centimes || 0;
        this.taux_tva = parseFloat(data.taux_tva) || 0;
        this.taux_remise = parseFloat(data.taux_remise) || 0;
        this.total_ligne_centimes = data.total_ligne_centimes || 0;

        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
    }
}

export default AvoirsLignesModel;
